<ng-container>
  <p bitTypography="body1" class="tw-mb-0">
    {{ "duoRequiredByOrgForAccount" | i18n }}
  </p>
  <p bitTypography="body1">{{ "launchDuoAndFollowStepsToFinishLoggingIn" | i18n }}</p>
</ng-container>
